<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import AppHeader from '@/components/layout/AppHeader.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the ScrollTrigger plugin with GSAP
gsap.registerPlugin(ScrollTrigger);

const { locale } = useI18n();

onMounted(() => {
  // Check for saved language preference
  const savedLanguage = localStorage.getItem('preferredLanguage');
  if (savedLanguage) {
    locale.value = savedLanguage;
  }
  
  // Set document direction for RTL languages
  document.documentElement.dir = locale.value === 'ar' ? 'rtl' : 'ltr';
});
</script>

<template>
  <div :class="{ 'rtl': $i18n.locale === 'ar' }" class="app-container">
    <AppHeader />
    <main class="mt-16">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <AppFooter />
  </div>
</template>

<style>
@import 'styles/themes/default.css';
@import 'styles/tailwind.css';

/* Import Google Fonts for different languages */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;500;600;700&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css');

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-family-sans);
  @apply bg-white dark:bg-gray-900 text-gray-900 dark:text-white;
}

.rtl {
  direction: rtl;
  text-align: right;
}

.rtl .ml-2 {
  margin-left: 0;
  margin-right: 0.5rem;
}

.rtl .mr-2 {
  margin-right: 0;
  margin-left: 0.5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.rtl .text-left {
  text-align: right;
}
</style>
